import React from "react";
import Header from "./Header";
import vector1 from "./img/vector3.svg";
import "./About.css";
import { VscGithub, VscMail } from "react-icons/vsc";
import { FaDev } from "react-icons/fa";
import { AiFillFacebook, AiFillInstagram } from "react-icons/ai";
const About = () => {
  return (
    <>
      <div className="about">
        <img src={vector1} />

        
        <div className="aicons">
          <p>
            <VscGithub size={30} /> github.com/mishab-ka
          </p>
          <p>
            <FaDev size={30} />
            dev.to/mishabka
          </p>
          <p>
            <AiFillInstagram size={30} />
            @over_mine_
          </p>
          <p>
            <VscMail size={30} />
            mishabrock@gmail.com
          </p>
        </div>
      </div>
    </>
  );
};

export default About;
